










































































import { Component, Vue } from "vue-property-decorator";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";

@Component({
  components: {
    SimpleProfileSearch,
    DictionarySelect,
    PortalInput
  }
})
export default class CreateTaxEventModal extends Vue {
  
  private form: Partial<TaxEventPayload> = {};
  private amountLocal: number | string = '';
  private customerProfile: ProfileDTO | null = null;

  public beforeOpen(): void {
    this.form = {
      eventDate: '',
      paidOn: null,
      amountCents: 0,
      taxTypeId: null as any,
      customerId: null as any,
      customerType: null as any
    };
    this.amountLocal = '';
    this.customerProfile = null;
    // reset validation if vee-validate is used
    if (this.$validator) {
      this.$validator.reset();
    }
  }

  public closeModal(): void {
    this.$modal.hide('create-tax-event-modal');
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.form.customerId = profile.id;
      this.form.customerType = profile.type as any;
    } else {
      this.form.customerId = null as any;
      this.form.customerType = null as any;
    }
  }
  
  get isValid(): boolean {
    if (this.$validator && this.$validator.errors.items.length > 0) return false;
    return !!(this.form.customerId && this.form.taxTypeId && this.amountLocal && this.form.eventDate);
  }

  public async submit(): Promise<void> {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid) return;

    if (this.amountLocal) {
        this.form.amountCents = Math.round(parseFloat(this.amountLocal.toString()) * 100);
    }

    this.$loadOn();
    try {
      await TaxEventService.createTaxEvent(this.form as TaxEventPayload);
      this.closeModal();
      this.$emit('created');
    } catch (e) {
      processError(e, this);
    } finally {
      this.$loadOff();
    }
  }
}
